module.exports = __webpack_public_path__ + "img/imgrioa.bb1d6b89.png";